export default __webpack_public_path__ + "static/151-d9773420e9556f68f512912339ab3fc1.jpg";